module.exports = __webpack_public_path__ + "img/logo.e5603808.svg";